import { inDateInterval } from '../../../../../../../../Utils/utils';
import {
  TEDEKBokforderMeddelandeAVSANDAR_TYPEnum,
  TEDEKBokforderTYPEnum,
} from '../../../../../../../../globalQueryTypes';
import {
  BokforderQuery_node_TEDEKBokforder__Associations_Meddelande_All,
  BokforderQuery_node_TEDEKBokforder__Associations_Rader__Associations_Attestant,
  BokforderQuery_node_TEDEKBokforder__Associations_Rader__Associations_Attestant__Associations_Franvaro_All,
} from '../../../Queries/_QueryTypes/BokforderQuery';
import { BokforderType__Associations_Meddelande_All } from '../../../Queries/_QueryTypes/BokforderType';

export const isSenderOfMessage = (
  message: BokforderType__Associations_Meddelande_All,
  userID: string
) => {
  switch (message.AVSANDAR_TYP) {
    case TEDEKBokforderMeddelandeAVSANDAR_TYPEnum.FRAN_BESTALLARE:
      return message._Associations?.Bestallare?.id === userID;

    case TEDEKBokforderMeddelandeAVSANDAR_TYPEnum.FRAN_ATTESTANT:
      return message._Associations?.Attestant?.id === userID;

    case TEDEKBokforderMeddelandeAVSANDAR_TYPEnum.FRAN_EKONOM:
      return message._Associations?.Ekonom?.id === userID;

    default:
      return false;
  }
};

export const compareBokforderMessage = (
  a: BokforderType__Associations_Meddelande_All,
  b: BokforderType__Associations_Meddelande_All
) => {
  const aDate = new Date(a.TID);
  const bDate = new Date(b.TID);
  if (aDate < bDate) {
    return 1;
  }

  if (aDate > bDate) {
    return -1;
  }

  if (aDate === bDate) {
    return 0;
  }

  return 0;
};

export const isUserReservForFranvaro = (
  franvaro: BokforderQuery_node_TEDEKBokforder__Associations_Rader__Associations_Attestant__Associations_Franvaro_All,
  attestantID: string | null | undefined,
  type: TEDEKBokforderTYPEnum | null | undefined,
  today: Date
) => {
  const tomDate = new Date(new Date(franvaro?.TomDatum).setHours(23, 59, 59));
  const fromDate = new Date(franvaro?.DATUM_FROM);

  const isInDateInterval = inDateInterval(fromDate, tomDate, today);

  const isForUtanordning = Boolean(franvaro?.FOR_UTANORDNING);
  const isForBokforder = Boolean(franvaro?.FOR_BOKFORDER);

  const franvaroIsForType =
    type === TEDEKBokforderTYPEnum.BOKFORINGSORDER
      ? isForBokforder
      : type === TEDEKBokforderTYPEnum.UTANORDNING
      ? isForUtanordning
      : false;

  return (
    franvaro._Associations?.Reserv?.id === attestantID &&
    isInDateInterval &&
    franvaroIsForType
  );
};

export const getMessageLabel = (
  message: BokforderQuery_node_TEDEKBokforder__Associations_Meddelande_All,
  isMessageByAttestant: boolean,
  attestantSender:
    | BokforderQuery_node_TEDEKBokforder__Associations_Rader__Associations_Attestant
    | null
    | undefined,
  reservForUser:
    | BokforderQuery_node_TEDEKBokforder__Associations_Rader__Associations_Attestant
    | null
    | undefined
) => {
  if (!message.AvsandareDatumTid) {
    return 'Nytt meddelande';
  }

  if (
    isMessageByAttestant &&
    attestantSender == undefined &&
    reservForUser != null
  ) {
    return (
      message.AvsandareDatumTid + ' (reserv för ' + reservForUser?.Name + ')'
    );
  }

  return message.AvsandareDatumTid;
};
